export default __webpack_public_path__ + "static/media/4.8e3dc5db.png";